import { render } from "./AddNewStory.vue?vue&type=template&id=106a03ea&lang=html"
import script from "./AddNewStory.vue?vue&type=script&lang=js"
export * from "./AddNewStory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__